import { useEffect, useState } from 'react';

const useDevicePixelRatio = (): number | undefined => {
  const [devicePixelRatio, setDevicePixelRatio] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    const updateDevicePixelRatio = () => {
      setDevicePixelRatio(Math.ceil(window.devicePixelRatio));
    };

    const mediaQuery = window.matchMedia(
      `(resolution: ${window.devicePixelRatio}dppx)`
    );
    mediaQuery.addEventListener('change', updateDevicePixelRatio);

    return () => {
      mediaQuery.removeEventListener('change', updateDevicePixelRatio);
    };
  }, []);

  return devicePixelRatio;
};

export default useDevicePixelRatio;
